import { createFileRoute } from '@tanstack/react-router'
import { AccountPanel } from '../components/platform/SettingsPanels.tsx'

export const Route = createFileRoute('/_authed/_shell/settings/account')({
  component: AccountPanel,
})
